//Styles.js
import React from 'react'
import { StyleSheet } from 'react-native'

global.border = 0;
//const font = 'Courier New';
const font = 'Arial';
//const font = 'Times New Roman';
//const font = 'Klee One';
//const font = 'Consolas';

const styles = StyleSheet.create({
  //border: 1,
  containerMobile: {
    backgroundColor: 'white',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: '#666666',
    //borderLeft: 1,
    //marginTop: '1%',
    //flexDirection: 'row',
    flexDirection: 'column',
    borderWidth: border,
    //flex: 1,
    marginHorizontal: 8,
    //height: 640,
    //height: '100%',
    //paddingTop: StatusBar.currentHeight,
  },
  container: {
    backgroundColor: 'white',
    //borderLeft: 1,
    //marginTop: '1%',
    //flexDirection: 'row',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: '#666666',
    flexDirection: 'column',
    borderWidth: border,
    marginHorizontal: 8,
    //flex: 1,
    //height: 640,
    //height: '100%',
    //paddingTop: StatusBar.currentHeight,
  },
  head: {
    flexDirection: 'row',
    borderWidth: border,
    justifyContent: 'space-between',
  },
  principal: {
    backgroundColor: 'white',
    marginHorizontal: 10,
    width: '80%',
    borderWidth: border,
    //flexDirection: 'row',
    flexDirection: 'column',
    //height: '100%',
    //flex: 1, //?
    //marginVertical: 2,
  },
  lateral: {
    //flex: -1,
    borderWidth: border,
    backgroundColor: 'white',
    width: '20%',
    //height: '100%',
    height: 600,
    //flexDirection: 'row',
    flexDirection: 'column',
  },
  principalMobile: {
    //flex: 1,
    borderWidth: border,
    backgroundColor: 'white',
    flexDirection: 'column',
    //width: '100%',
    //height: '100%',
    //height: 420,
  },
  Column: {
    //width: '50%',
    //height: 100,
    borderWidth: border,
    flexDirection: 'column',
  },
  row: {
    //width: '50%',
    borderWidth: border,
    flexDirection: 'row',
    //height: 100,
  },
  //social: {
  //  borderWidth: border,
  //},
  articles: {
    //flexDirection: 'row',
    flexDirection: 'column',
    borderWidth: border,
    //height: 120, //?
    //flex: 1,
  },
  articlesRow: {
    flexDirection: 'row',
    borderWidth: border,
    //height: 120, //?
    //flex: 1,
  },
  articlesColumn: {
    flexDirection: 'column',
    borderWidth: border,
    //height: 120, //?
    //flex: 1,
  },
  articlesMobile: {
    flexDirection: 'column',
    borderWidth: border,
    //height: 120, //?
    //flex: 1,
  },
  articlesRowMobile: {
    flexDirection: 'row',
    borderWidth: border,
    //height: 120, //?
    //flex: 1,
  },
  articlesColumnMobile: {
    flexDirection: 'column',
    borderWidth: border,
    width: '50%',
    //height: 120, //?
    //flex: 1,
  },
  copyrightMobile: {
    borderWidth: border,
    flexDirection: 'column',
    //height: '100%',
    //height: 40,
    //flex: 1,
  },
  copyright: {
    borderWidth: border,
    flexDirection: 'column',
    //height: '100%',
    //height: 40,
    //flex: 1,
  },
  button: {
    borderWidth: border,
    width: 120,
  },
  baseText: {
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 28,
    color: '#666666', //dark gray 1
  },
  baseTextBlack: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 28,
    color: 'black', //dark gray 1
  },
  titleText: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: '#666666', //dark gray 1
  },
  titleTextRed: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: '#c9211e', //dark red 2
  },
  titleTextBlack: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: 'black',
  },
  link: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: '#666666', //dark gray 1
    textDecorationLine: 'underline',
  },
  linkBlack: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: 'black',
    //onPress
    textDecorationLine: 'underline',
  },
  linkBlackBig: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 24,
    color: 'black',
    //onPress
    textDecorationLine: 'underline',
  },
  linkRed: {
    //fontFamily: 'Open Sans',
    //fontFamily: 'Courier New',
    fontFamily: font,
    fontSize: 18,
    color: '#c9211e', //dark red 2
    //onPress
    textDecorationLine: 'underline',
  },
  logo: {
    //alignItems: 'center',
    borderWidth: border,
    width: 270,
    height: 270,
    resizeMode: 'contain',
  },
  logoMobile: {
    borderWidth: border,
    //width: '100%',
    //height: '10%',
    width: 270,
    height: 270,
    resizeMode: 'contain',
  },
  logoView: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: border,
    //width: 270,
    //height: 270,
    //resizeMode: 'contain',
  },
  logoViewMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: border,
    //width: '100%',
    //height: '10%',
    //resizeMode: 'contain',
  },
  center: {
    //flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
export default styles;
